// extracted by mini-css-extract-plugin
export default {"wrap":"TextColorMenu_wrap__a6B3z","popover":"TextColorMenu_popover__PavbC","clear":"TextColorMenu_clear__+4lRw"};